"use strict";

_BannerFlowApp.directive("profileImage", function (AuthInfo) {
    return {
        restrict: "E",
        templateUrl: "/legacy-app/js/directives/profile-image.html",
        scope: {
            user: "=?",
            showArrow: "=?"
        },
        link: function (scope, element, attrs, controller) {
            var user = scope.user || AuthInfo.LoggedInUser;

            if (user.confirmed === false) {
                scope.initials = "?";
                scope.color = "#ddd";
                return;
            }

            // Ugly fix to make profile image work in comments
            if (user.name) {
                var getLastName = function (name) {
                    var arr = name.split(" ");
                    if (arr.length > 1) {
                        return arr[1];
                    } else {
                        return "";
                    }
                };

                user.firstName = user.name.split(" ")[0];
                user.lastName = getLastName(user.name);
            }

            if (user.firstName && user.lastName) {
                scope.initials = user.firstName[0].toUpperCase() + user.lastName[0].toUpperCase();
            } else if (!user.firstName || !user.lastName) {
                scope.initials = user.email[0].toUpperCase() + user.email[1].toUpperCase();
            }

            var grayColor = "#aaaaaa";
            var colors = [
                "#2CBC45",
                "#efcf00",
                "#f65d77",
                "#6c4a80",
                "#1B75DD",
                "#404040",
                "#2fa8ca",
                "#9a523a"
            ];

            scope.color = grayColor;

            var hashCode = function (s) {
                var hash = 0;
                if (s.length == 0) return hash;
                for (var i = 0; i < s.length; i++) {
                    var char = s.charCodeAt(i);
                    hash = hash + char;
                }
                return hash;
            };

            var index = hashCode(user.email) % colors.length;
            scope.color = colors[index];
        }
    };
});
